export default __webpack_public_path__ + "static/media/astarsimulation_demo_image.9cc09111.gif";